import { getToken } from './tokenService';
import { isStorageItem } from '../utils/isStorageItem';

export const getSelectedRideId = rideId => {
  if (rideId) return rideId;

  const id = isStorageItem('rideId');
  if (!!id && id !== 'null') return id;

  const token = getToken();
  if (!token.isToken()) return;
  return token.rideId;
};

export const updateData = (fullDataRide, details) => {
  if (details.pickup_location) {
    updateStatus(details, details.status, fullDataRide);
  }
  if (details.pickup_location) {
    updateLocationData('pickup', fullDataRide, details.pickup_location);
  }
  if (details.dropoff_location) {
    updateLocationData('dropoff', fullDataRide, details.dropoff_location);
  }
  if (details.vehicle) {
    updateOtherData(details, details.vehicle, fullDataRide);
  }
};

export const updateLocationData = (prefix, fullDataRide = {}, newData) => {
  for (const name in newData) {
    const oldFieldName = `${prefix}_${name}`;

    const newValue = newData[name] || null;
    const oldValue = fullDataRide[oldFieldName] || null;

    if (oldValue && newValue !== oldValue) {
      fullDataRide[oldFieldName] = newValue;
    }
  }
};

export const updateOtherData = (oldData = {}, newData = {}, updatedRideData) => {
  if (!updatedRideData) return;

  if (oldData?.driver_name !== newData?.driver_name) {
    updatedRideData.driver_name = newData?.driver_name || null;
  }
  if (oldData?.vehicle_number !== newData?.vehicle_number) {
    updatedRideData.vehicle_number = newData.vehicle_number;
  }

  if (oldData?.fleet) {
    if (!updatedRideData.fleet) {
      updatedRideData.fleet = {};
    }
    const oldFleet = oldData.fleet;

    if (oldFleet.name !== newData.fleet_name) {
      updatedRideData.fleet.name = newData.fleet_name;
    }
    if (oldFleet.name !== newData.fleet_phone_number) {
      updatedRideData.fleet.phone_number_formatted = newData.fleet_phone_number;
    }
  }
};

export const updateStatus = (oldData = {}, newData = {}, updatedRideData) => {
  if (!updatedRideData) return;
  updatedRideData.state = newData.status_code;
};

export const getIconUrl = vehicle => {
  const type = vehicle.serviceType;
  const isAccessible = vehicle.isAccessible;
  let folder = 'yellow-car';

  if (type === 'limo') {
    folder = 'grey-car';
  }

  if (isAccessible) {
    folder += '-accessible';
  }

  let deg = 0;
  const heading = vehicle.heading || 0;

  switch (true) {
    case heading === 0 || heading === 360:
    case heading > 330 && heading <= 360:
      deg = 0;
      break;
    case heading > 0 && heading <= 30:
      deg = 30;
      break;
    case heading > 30 && heading <= 60:
      deg = 60;
      break;
    case heading > 60 && heading <= 90:
      deg = 90;
      break;
    case heading > 90 && heading <= 120:
      deg = 120;
      break;
    case heading > 120 && heading <= 150:
      deg = 150;
      break;
    case heading > 150 && heading <= 180:
      deg = 180;
      break;
    case heading > 180 && heading <= 210:
      deg = 210;
      break;
    case heading > 210 && heading <= 240:
      deg = 240;
      break;
    case heading > 240 && heading <= 270:
      deg = 270;
      break;
    case heading > 270 && heading <= 300:
      deg = 300;
      break;
    case heading > 300 && heading <= 330:
      deg = 330;
      break;
    default:
      break;
  }

  return 'https://cdn.gocurb.com/img/map_icons/' + folder + '/car-' + deg + '.png';
};

export const convertStateToColor = state => {
  const colorList = {
    white: '#ffffff',
    yellow: '#ffe037',
    orange: '#f3c169',
    green: '#1cb684',
    pink: '#fa7373',
    terracotta: '#e87f66',
    indigo: '#4b0082',
    ebony: '#212937',
  };
  let color = null;
  const borderColor = colorList.white;

  switch (state) {
    case 'assigned':
    case 'dispatched':
    case 'created':
      color = colorList.yellow;
      break;
    case 'on_site':
      color = colorList.orange;
      break;
    case 'meter_on':
    case 'enroute':
    case 'started':
      color = colorList.green;
      break;
    case 'canceled':
    case 'missed':
    case 'manual_dispatch':
      color = colorList.pink;
      break;
    case 'review':
      color = colorList.indigo;
      break;
    case 'completed':
      color = colorList.ebony;
      break;
    default:
      console.log('Unknown state : ' + state);
      color = colorList.terracotta;
      break;
  }

  return [color, borderColor];
};

export const shouldRestartPoly = (eventName, isCancelChecked) => {
  const baseCondition = eventName === 'manual_dispatch' || eventName === 'reassigning';

  if (isCancelChecked) {
    return baseCondition || eventName === 'canceled';
  }
  return baseCondition;
};

export const centerMap = config => {
  const { mapbox, lng, lat, isLoaded, zm } = config;

  if (mapbox) {
    if (isLoaded) {
      mapbox.flyTo({ center: [lng, lat], zoom: zm || 8 });
    } else {
      mapbox.on('load', function () {
        mapbox.flyTo({ center: [lng, lat], zoom: zm || 8 });
      });
    }
  }
};
